export const LABELS = {
  APPLICATION_FILE: "申請ファイル",
  APPLICATION_TYPE_HEADER: "申請単位は",
  APPLICATION_TYPE_FOOTER: "となります。",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  ERROR_DETAIL: "エラー内容",
  FOR_STORE: "店舗情報申請書",
  ERROR_TITLE_FOR_STORE: "店舗情報申請エラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
  APPLICANT_COMPANY: "申請事業者",
  MAINTENANCE_LABEL: "メンテナンス",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION: ".xlsx",
  UPLOAD_TYPE: "uploadType",
  APPLICANT_COMPANY_CODE: "applicantCompanyCode",
  STORE: "店舗申請用",
  MAINTENANCE_FLG: "maintenanceFlg",
  TARGET: "target",
} as const;

export const CONTENTS = {
  APPLICATION_CONFIRM: "\r\n・店舗情報申請書\r\n　　ファイル名：{0}",
  CLOSED_STORE_COUNT_CONTENT: "閉店店舗数は、{0}件です。\r\n",
  ALL_APPLICATION_CONFIRM:
    "閉店が含まれています。この申請でよろしいでしょうか？\r\n\r\n",
} as const;

/** チェック対象：直接店舗 */
export const CHECK_TARGET_DIRECT_STORE = "2";
